import { Card, Col, Row, Table } from "react-bootstrap";

const ConnectionRequests = ({ connectionRequests }) => {
  return (
    <div>
      {connectionRequests && connectionRequests.map((item) => (
        <Card key={item.id} className="mb-4 shadow-sm">
          <Card.Header>
            <strong>#ID: {item.id}</strong>
          </Card.Header>
          <Card.Body>
            <Table bordered hover responsive className="mb-3">
              <tbody>
                <tr>
                  <th>İsim</th>
                  <td>{item.name}</td>
                  <th>Soyisim</th>
                  <td>{item.surname}</td>
                  <th>Şirket</th>
                  <td>{item.company}</td>
                </tr>
                <tr>
                  <th>Ünvan</th>
                  <td>{item.title}</td>
                  <th>Email</th>
                  <td>{item.email}</td>
                  <th>Telefon</th>
                  <td>{item.phoneNumber}</td>
                </tr>
                <tr>
                  <th>Şehir</th>
                  <td>{item.city}</td>
                  <th>Alan</th>
                  <td>{item.domain}</td>
                  <th>Oluşturma Tarihi</th>
                  <td>{new Date(item.creationDate).toLocaleString()}</td>
                </tr>
              </tbody>
            </Table>
            <Row>
              <Col>
                <strong>Konu:</strong>
                <div className="mt-2" style={{ whiteSpace: "pre-wrap" }}>
                  {item.subject}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};
export default ConnectionRequests;
